/**
 * Inventory (assistant role test 2026-10-20, fix 7). Route `/inventory`:
 * the office's supplies with par level, count on hand and a reorder flag;
 * count with one tap (+ / -) or a new total. Office-scoped and audited.
 */
import { defineManifest } from '@velora/contracts';
import { INVENTORY_ENTITY, INVENTORY_PERMISSIONS as P } from '@velora/contracts/inventory';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'inventory',
    title: 'Inventory',
    version: '0.1.0',
    owner: 'WP4-INVENTORY',
    entitlementKey: null,
    permissions: [...new Set(Object.values(P))],
    routes: [
      {
        id: 'items',
        path: '/inventory',
        title: 'Inventory',
        officeScope: 'location',
        permission: P.view,
        readsPhi: false,
      },
    ],
    nav: [
      {
        label: 'Inventory',
        group: 'clinical',
        routeId: 'items',
        icon: 'package',
        order: 85,
        permission: P.view,
      },
    ],
    commands: [
      {
        id: 'inventory.items',
        title: 'Inventory and supplies',
        keywords: ['inventory', 'supplies', 'stock', 'reorder', 'par', 'gloves', 'order'],
        routeId: 'items',
        permission: P.view,
      },
    ],
    sseEntityKeys: [INVENTORY_ENTITY],
    phiReadPoints: [],
  }),
  pages: {
    items: () => import('./InventoryPage.js'),
  },
});
